import { Button, Img, Line, Text } from "components";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as CUSTOM from "../../../../utils/helper/custom";
import { mergeAndSortStatuses } from "../../../../utils/helper/custom";

let statusIgnoreArray = [
  "no_show",
  "cancelled",
  "rejected",
  "placed",
  // "under_qa",
  // "under_qa",
  //"ready_to_pick",
];

// ── Track History Popup Modal ──────────────────────────────────────────────────
const TrackHistoryModal = ({ isOpen, onClose, children, currentOrderStatus, imgURl, statusText, statusDate, t }) => {
  
  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    if (isOpen) window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[100] bg-black-900 opacity-50"
        onClick={onClose}
      />
      {/* Modal */}
      <div className="fixed inset-0 z-[101] flex items-center justify-center px-4">
        <div className="bg-white-A700 rounded-2xl w-full max-w-[560px] max-h-[80vh] flex flex-col overflow-hidden shadow-xl">
          {/* Modal Header */}
          <div className="flex flex-row items-center justify-between px-6 py-4 border-b border-gray-100">
            <div className="flex flex-row items-center gap-3">
              <Img className="h-7 w-7" src={imgURl} alt="status" />
              <div className="flex flex-col">
                <Text className="text-sm font-['Inter'] text-black-900 leading-tight">
                  {statusText}
                </Text>
                <Text className="text-xs font-['Inter'] text-gray-500 leading-tight mt-0.5">
                  {statusDate}
                </Text>
              </div>
            </div>
            <button
              className="flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              onClick={onClose}
            >
              <Img
                className="h-4 w-4"
                src="/images/img_close_gray_700.svg"
                alt="close"
              />
            </button>
          </div>

          {/* Modal Body — scrollable */}
          <div className="flex-1 overflow-y-auto px-6 py-4">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

const TrackHistory = ({ orderData, type }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [lastStatusData, setLastStatusData] = useState({});
  const [imgURl, setImgUrl] = useState("");
  const [currentOrderStatus, setCurrentOrderStatus] = useState("");
  const [statusText, setStatusText] = useState("");
  const [statusDate, setStatusDate] = useState("");

  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState);
  };

  useEffect(() => {
    setImgUrl(CUSTOM.orderStatusImgages(currentOrderStatus));
  }, [currentOrderStatus]);

  /**
   * set order status
   */
  useEffect(() => {
    let resData = CUSTOM.getLastStatusData(orderData?.orderStatusLogs, orderData?.status);
    let status = resData?.status;
  
    const recipientSubmittedStatus = CUSTOM.getDateFromGiftStatusLog(orderData?.giftStatusLogs, "recipientFilledForm");
    const giftLinkSentStatus = CUSTOM.getDateFromGiftStatusLog(orderData?.giftStatusLogs, "giftLinkSentAt");
  
    if (orderData?.orderType === "gift" && status === "pending") {
      if (recipientSubmittedStatus) {
        status = "recipientFilledForm";
      } else if (giftLinkSentStatus) {
        status = "giftLinkSentAt";
      }
    }
  
    if (orderData?.orderType === "custom_cake_gift" && status === "approved") {
      status = "pending";
    }
    if (orderData?.deliveryMode === "pickup" && (status === "out_for_delivery" || status === "ready_to_pick")) {
      status = "under_qa";
    }
    if (status === "pickup_delivered") {
      status = "ready_to_pick";
    }
  
    setCurrentOrderStatus(status);
  
    let statusKey;
    if (status === "recipientFilledForm") {
      statusKey = CUSTOM.statusByKey("recipient_submited", "on");
    } else if (status === "giftLinkSentAt") {
      statusKey = CUSTOM.statusByKey("giftlinksentAt", "on");
    } else {
      statusKey = CUSTOM.statusByKey(status, "on");
    }
    setStatusText(t(statusKey));

    const statusLogDate =
      status === "recipientFilledForm"
        ? recipientSubmittedStatus
        : status === "giftLinkSentAt"
        ? giftLinkSentStatus
        : CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, status);
  
    setStatusDate(CUSTOM.convertDateString(statusLogDate, "dd/MM/yyyy hh:mm a"));
  
  }, [orderData]);
  
  
  useEffect(() => {
    if (orderData?.deliveryMode == "pickup") {
      statusIgnoreArray.push("out_for_delivery");
    }
  }, [orderData]);

  const statuses = mergeAndSortStatuses({
    orderStatuses: orderData?.orderStatusLogs,
    giftStatuses: orderData?.giftStatusLogs,
    allStatusesList: CUSTOM.getAllOrderStatus(type),
    statusesToIgnore: statusIgnoreArray,
    type,
    giftType: orderData?.giftType,
    t,
    statusByKey: CUSTOM.statusByKey,
    statusMessageByKey: CUSTOM.statusMessageByKey,
    convertDateString: CUSTOM.convertDateString,
    getDateFromGiftStatusLog: CUSTOM.getDateFromGiftStatusLog,
    getDateFromStatusLog: CUSTOM.getDateFromStatusLog,
  });

  // ── Shared track history content (used inside popup) ──
  const renderTrackContent = (statusList, mode) => (
    <>
      {statusIgnoreArray.indexOf(currentOrderStatus) == -1 ? (
        <>
          {statusList.map((log, index) => {
            const isGift = mode === "gift";
            const status = isGift ? log?.status : t(CUSTOM.statusByKey(log));
            const message = isGift ? log?.message : t(CUSTOM.statusMessageByKey(log));
            const date = isGift
              ? log?.date
                ? CUSTOM.convertDateString(log.date, "dd/MM/yyyy hh:mm a")
                : null
              : CUSTOM.convertDateString(
                  CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, log, ""),
                  "dd/MM/yyyy hh:mm a"
                );
            const hasDate = isGift ? !!log?.date : !!CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, log, "");
            const isCustomCakePending =
              mode === "custom_cake" &&
              ((orderData?.orderStatusLogs.length == 1 && log == "pending") ||
                (orderData?.orderStatusLogs.length == 2 && statusIgnoreArray.includes(currentOrderStatus)));

            return (
              <div
                className="flex flex-row gap-4 items-start justify-start w-full mt-5 mb-5 relative xs:flex-wrap"
                key={`status-${index}-${Math.random()}`}
              >
                <div className={`progress-line ${hasDate ? "success" : "gray"}`}></div>
                <Img
                  className="h-6 w-6 relative z-[10]"
                  src={
                    isCustomCakePending
                      ? CUSTOM.orderStatusImgages("pending")
                      : hasDate
                      ? "/images/img_check_circle.svg"
                      : "/images/gray-dot.svg"
                  }
                  alt="check"
                />
                <div className="flex flex-col items-start justify-start w-full title">
                  <Text className="text-black-900 text-sm w-auto font-nunitomedium">{status}</Text>
                  <Text className="text-gray-700 text-[12px] w-auto font-nunitoregular">{message}</Text>
                </div>
                <div className="flex flex-col items-end justify-start w-auto xs:ml-10">
                  <Text className="text-black-900 text-sm w-auto font-nunitoregular whitespace-nowrap">{date}</Text>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <>
          {orderData?.orderStatusLogs.map((itemss, index) => {
            let items = itemss?.status;
            if (statusIgnoreArray.indexOf(items) !== -1) return null;
            return (
              <div
                className="flex flex-row gap-4 items-start justify-start w-full mt-5 mb-5 relative xs:flex-wrap"
                key={`keyid-${index}-${Math.random()}`}
              >
                <div className="progress-line success"></div>
                <Img
                  className="h-6 w-6 relative z-[10]"
                  src={
                    !CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, items, "")
                      ? "/images/gray-dot.svg"
                      : "/images/img_check_circle.svg"
                  }
                  alt="check"
                />
                <div className="flex flex-col items-start justify-start w-full title">
                  <Text className="text-black-900 text-sm w-auto font-nunitomedium">
                    {t(CUSTOM.statusByKey(items))}
                  </Text>
                  <Text className="text-gray-700 text-[12px] w-auto font-nunitoregular">
                    {t(CUSTOM.statusMessageByKey(items))}
                  </Text>
                </div>
                <div className="flex flex-col items-end justify-start w-auto xs:ml-10">
                  <Text className="text-black-900 text-sm w-auto font-nunitoregular whitespace-nowrap">
                    {CUSTOM.convertDateString(
                      CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, items),
                      "dd/MM/yyyy hh:mm a"
                    )}
                  </Text>
                </div>
              </div>
            );
          })}
        </>
      )}

      {statusIgnoreArray.indexOf(currentOrderStatus) !== -1 ? (
        <div className="flex flex-row gap-4 items-start justify-start w-full mt-5 mb-5 relative xs:flex-wrap">
          <div className="progress-line error"></div>
          <Img className="h-6 w-6 relative z-[10]" src={CUSTOM.orderStatusImgages(currentOrderStatus)} alt="check" />
          <div className="flex flex-col items-start justify-start w-full title">
            <Text className="text-black-900 text-sm w-auto font-nunitomedium">
              {t(CUSTOM.statusByKey(currentOrderStatus))}
            </Text>
            <Text className="text-gray-700 text-[12px] w-auto font-nunitoregular">
              {t(lastStatusData?.reason ? lastStatusData?.reason : CUSTOM.statusMessageByKey(currentOrderStatus))}
            </Text>
          </div>
          <div className="flex flex-col items-end justify-start w-auto xs:ml-10">
            <Text className="text-black-900 text-sm w-auto font-nunitoregular whitespace-nowrap">
              {CUSTOM.convertDateString(
                CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, currentOrderStatus),
                "dd/MM/yyyy hh:mm a"
              )}
            </Text>
          </div>
        </div>
      ) : null}
    </>
  );

  // ── Shared trigger row ──
  const renderTriggerRow = (dateDisplay) => (
    <>
      <div
        className="flex flex-col gap-[0px] items-center justify-start w-full cursor-pointer"
        onClick={toggleVisibility}
      >
        <div className="flex sm:flex-wrap flex-row py-3 items-center justify-between sm:justify-end w-full">
          {/* <div className="flex flex-row gap-4 items-center justify-start w-auto w-full">
            <Img className="h-8 w-8" src={imgURl} alt="warning" />
            <Text className="text-black-900 text-sm w-auto font-nunitomedium">
              {statusText} {dateDisplay}
            </Text>
          </div> */}
          {/* Changed: button now says "Track History" and opens popup on click */}
          <Button
            className="px-4 py-2 text-sm font-semibold text-gray-700 border border-gray-300 rounded-full hover:border-gray-400 hover:bg-gray-50 transition-colors font-['Inter']"
            size="md"
            // rightIcon={
            //   <Img className="h-5 w-5" src="/images/dow-red-icon.svg" alt="arrow_down" />
            // }
          >
            {t("trackHistory")}
          </Button>
        </div>
      </div>

      {/* 
        Old: toggle-content accordion was here:
        <div className={`toggle-content pl-1 ${isVisible ? "show" : ""}`}>
          ...content...
        </div>
      */}
    </>
  );

  return (
    <>
      {/* ── GIFT type ── */}
      {type == "gift" ? (
        <div>
          {renderTriggerRow(statusDate)}

          {/* Popup Modal */}
          <TrackHistoryModal
            isOpen={isVisible}
            onClose={() => setIsVisible(false)}
            currentOrderStatus={currentOrderStatus}
            imgURl={imgURl}
            statusText={statusText}
            statusDate={statusDate}
            t={t}
          >
            {renderTrackContent(statuses, "gift")}
          </TrackHistoryModal>
        </div>
      ) : null}

      {/* ── REGULAR type ── */}
      {type == "regular" ? (
        <div>
          {renderTriggerRow(
            CUSTOM.convertDateString(
              CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, currentOrderStatus),
              "dd/MM/yyyy hh:mm a"
            )
          )}

          <TrackHistoryModal
            isOpen={isVisible}
            onClose={() => setIsVisible(false)}
            currentOrderStatus={currentOrderStatus}
            imgURl={imgURl}
            statusText={t(CUSTOM.statusByKey(currentOrderStatus, "on"))}
            statusDate={CUSTOM.convertDateString(
              CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, currentOrderStatus),
              "dd/MM/yyyy hh:mm a"
            )}
            t={t}
          >
            {renderTrackContent(CUSTOM.getAllOrderStatus("regular"), "regular")}
          </TrackHistoryModal>
        </div>
      ) : null}

      {/* ── CUSTOM CAKE type ── */}
      {type == "custom_cake" ? (
        <div>
          {renderTriggerRow(
            CUSTOM.convertDateString(
              CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, currentOrderStatus),
              "dd/MM/yyyy hh:mm a"
            )
          )}

          <TrackHistoryModal
            isOpen={isVisible}
            onClose={() => setIsVisible(false)}
            currentOrderStatus={currentOrderStatus}
            imgURl={imgURl}
            statusText={t(CUSTOM.statusByKey(currentOrderStatus, "on"))}
            statusDate={CUSTOM.convertDateString(
              CUSTOM.getDateFromStatusLog(orderData?.orderStatusLogs, currentOrderStatus),
              "dd/MM/yyyy hh:mm a"
            )}
            t={t}
          >
            {renderTrackContent(CUSTOM.getAllOrderStatus("custom_cake"), "custom_cake")}
          </TrackHistoryModal>
        </div>
      ) : null}

      {/* end */}
    </>
  );
};

export default TrackHistory;